<template>
  <div id="project-form">
    <form @submit.prevent="submit" v-if="loaded">
      <section class="main-content columns is-fullheight">
        <aside class="column is-narrow sidebar">
          <ul class="menu-list">
            <li v-for="node in tree" :key="node.label">
              <nav-item
                v-model="form"
                :errors="errors"
                :node="node"
                :path="[node.path]"
                :errorsPaths="errorsPaths"
              />
            </li>
          </ul>
        </aside>
        <div class="column form-container">
          <section v-if="currentNode">
            <b-field horizontal>
              <div class="title">{{ currentNode.label }}</div>
            </b-field>
            <fields v-model="form" :errors="errors" :node="currentNode"/>
            <input class="button is-success" type="submit" value="Save">
            <a
              class="button is-info"
              :href="`http://${domain}/initialize`"
              target="_blank"
            >Initialize</a>
            <a
              class="button is-info"
              @click.prevent="flushCache"
            >Flush Cache</a>
            <a
              class="button is-info"
              @click.prevent="flushGameCache"
            >Flush Game Cache</a>
            <router-link class="button submit is-danger is-pulled-right" to="/projects">Back</router-link>
          </section>
        </div>
      </section>
    </form>
  </div>
</template>

<script>
import { validate as validateJsonSchema } from 'jsonschema'
import objectPath from 'object-path'
import http from '@/lib/utils/http'
import { pick } from '@/lib/utils/object'
import { error, success } from '@/lib/utils/toast'
import NavItem from './NavItem'
import tree from './tree'
import FrontendSchema from './Frontend/Schema.json'
import migrate from './Frontend/migrate'
import { serializeForm, flattenObject, findNodeByPath } from './helpers'
import axios from 'axios'

export default {
  props: ['id'],
  data() {
    return {
      loaded: false,
      form: {},
      errors: {
        frontConfiguration: {},
      },
      tree,
    }
  },
  components: {
    NavItem,
  },
  computed: {
    path() {
      const hash = this.$route.hash.slice(1) || 'general'
      return hash.split('/')
    },
    currentNode() {
      return findNodeByPath(this.tree, this.path)
    },
    errorsPaths() {
      return Object.keys(flattenObject(this.errors))
    },
    domain() {
      return (this.form.domain[0] && this.form.domain[0].data) || ''
    },
  },
  methods: {
    flushCache() {
      const domain = (this.form.domain[0] && this.form.domain[0].data) || ''
      const one = http.get(`https://${domain}/init?s=1&config=Ed[MDB7X!MZn}Zd&type=main`)
      const two = http.get(`https://${domain}/init?s=2&config=Ed[MDB7X!MZn}Zd`)
      const three = http.get(`https://${domain}/init?s=3&config=Ed[MDB7X!MZn}Zd`)
      const four = http.get(`https://${domain}/init?s=4&config=Ed[MDB7X!MZn}Zd`)
      const loader = this.$loading.open()
      axios
        .all([one, two, three, four])
        .then(
          axios.spread((...repsonses) => {
            const responseOne = repsonses[0]
            const responseTwo = repsonses[1]
            const responesThree = repsonses[2]
            loader.close()
          })
        )
        .catch(e => {
          loader.close()
        })
    },
    flushGameCache() {
      const domain = (this.form.domain[0] && this.form.domain[0].data) || ''
      const one = http.get(`https://${domain}/init?s=1&config=Ed[MDB7X!MZn}Zd&type=games`)
      const two = http.get(`https://${domain}/init?s=2&config=Ed[MDB7X!MZn}Zd`)
      const three = http.get(`https://${domain}/init?s=3&config=Ed[MDB7X!MZn}Zd`)
      const four = http.get(`https://${domain}/init?s=4&config=Ed[MDB7X!MZn}Zd`)
      const loader = this.$loading.open()
      axios
        .all([one, two, three, four])
        .then(
          axios.spread((...repsonses) => {
            const responseOne = repsonses[0]
            const responseTwo = repsonses[1]
            const responesThree = repsonses[2]
            loader.close()
          })
        )
        .catch(e => {
          loader.close()
        })
    },
    load() {
      const loader = this.$loading.open()
      const url = this.id ? 'form/projects/' + this.id : 'form/projects'
      const stage = process.env.STAGE

      http
        .get(url)
        .then(resp => {
          const data = Object.assign({}, resp.data)
          const frontendData = migrate(data.frontConfiguration.data, stage, data.name).data
          data.frontConfiguration.data = frontendData

          this.form = data
          this.loaded = true
        })
        .catch(e => {
          console.log(e)
        })
        .then(() => {
          loader.close()
        })
    },
    submit() {
      const body = serializeForm(this.form)

      const result = validateJsonSchema(body.frontConfiguration, FrontendSchema)
      if (!result.valid) {
        this.fillFrontendErrors(result)
        this.$toast.open(error())
        console.log(result)
        return
      }

      const loader = this.$loading.open()
      const request = this.id ? http.put('projects/' + this.id, body) : http.post('projects', body)
      console.log(body)

      request
        .then(() => {
          loader.close()
          this.errors = {}
          this.$toast.open(success())
        })
        .catch(errors => {
          loader.close()
          this.errors = errors.response && errors.response.data
          this.$toast.open(error())
        })
    },
    fillFrontendErrors(result) {
      const errors = result.errors.reduce((acc, error) => {
        const match = error.property.match(/^instance\[\"(.*)\"\]$/)
        if (match && match[1]) return { [match[1]]: [{ message: error.message }] }
        return acc
      }, {})
      this.errors.frontConfiguration = { data: errors }
    },
  },
  created() {
    this.load()
  },
}
</script>

<style scoped>
.sidebar {
  position: fixed;
  width: 250px;
  height: calc(100% - 60px);
  padding-right: 0;
  overflow-y: scroll;
}
.form-container {
  padding-left: 270px;
}
</style>





// WEBPACK FOOTER //
// src/components/Projects/Form/Form.vue